<div class="delete-dialog">
  <h2 mat-dialog-title>Confirm Delete</h2>

  <mat-dialog-content>
    <div class="warning-message">
      <mat-icon class="warning-icon">warning</mat-icon>
      <p>Are you sure you want to delete this property binding?</p>
    </div>

    <div class="details-container">
      <h3 class="details-title">Property Binding Details</h3>

      <div class="detail-row">
        <span class="detail-label">Binding Name:</span>
        <span class="detail-value">{{ bindingName }}</span>
      </div>

      <div class="detail-row">
        <span class="detail-label">Target Field:</span>
        <span class="detail-value">{{ getTargetFieldDisplay() }}</span>
      </div>

      <div class="detail-row">
        <span class="detail-label">Shape:</span>
        <span class="detail-value">{{ getShapeDisplay() }}</span>
      </div>

      <div class="detail-row">
        <span class="detail-label">Default Color:</span>
        <span class="detail-value">
          <span class="color-preview" [style.background-color]="defaultColor"> </span>
          {{ defaultColor }}
        </span>
      </div>

      @if (hasColorData()) {
      <div class="color-data-section">
        <span class="detail-label">Color Options:</span>
        <div class="color-data-list">
          @for (item of getColorDataItems(); track item.value) {
          <div class="color-data-item">
            <span class="color-preview" [style.background-color]="item.color"> </span>
            <span class="color-data-value">{{ item.value }}</span>
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="warning-footer">
      <mat-icon class="info-icon">info</mat-icon>
      <p class="warning-text">This action cannot be undone.</p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()" class="cancel-button">Cancel</button>
    <button mat-raised-button color="warn" (click)="confirmDelete()" class="delete-button">Delete</button>
  </mat-dialog-actions>
</div>
